import React from 'react';

const ArrayFieldSection = ({
  field,
  formData,
  handleArrayChange,
  handleAddItem,
  handleRemoveItem,
  dropdownData,
}) => {
  const isArrayString =
  Array.isArray(field.subfields) &&
  field.subfields.length === 1 &&
  field.subfields[0]?.type === 'arrayString';


  const isSimpleArray = field.type === 'array' && !field.subfields;

  const subFieldName = Array.isArray(field.subfields) ? field.subfields[0]?.fields : '';


const values = React.useMemo(() => {
  const raw = formData[field.fields] || [];
  if (isArrayString && typeof raw[0] === 'string') {
    return raw.map((val) => ({ [subFieldName]: val }));
  }
  if (isSimpleArray && typeof raw[0] === 'string') {
    return raw.map((val) => ({ value: val }));
  }

  return raw;
}, [formData, field.fields, subFieldName, isArrayString, isSimpleArray]);

if (field.checkBox) {
  const selected = Array.isArray(formData[field.fields]) ? formData[field.fields] : [];

  const toggleCheckbox = (option) => {
    const isChecked = selected.includes(option);
    const updated = isChecked
      ? selected.filter((val) => val !== option)
      : [...selected, option];
    handleArrayChange(field.fields, null, null, updated);
  };

  return (
    <div className="form-group checkbox-array">
      <label className="form-label">{field.fields}</label>
      <div className="checkbox-array-list">
        {field.checkBox.map((option, i) => (
          <label key={i} className="checkbox-label">
            <input
              type="checkbox"
              checked={selected.includes(option)}
              onChange={() => toggleCheckbox(option)}
            />
            {option}
          </label>
        ))}
      </div>
    </div>
  );
}



  return (
    <div className="form-array-wrapper">
      {values.map((item, index) => (
        <div key={index} className="array-group">
          {isArrayString || isSimpleArray ? (
            <>
              <input
      className="form-input"
      type="text"
      value={item[isArrayString ? subFieldName : 'value'] || ''}
      onChange={(e) =>
        handleArrayChange(
          field.fields,
          index,
          isArrayString ? subFieldName : 'value',
          e.target.value
        )
      }
    />
              <button
                type="button"
                onClick={() => handleRemoveItem(field.fields, index)}
                className="remove-btn"
              >
                Remove
              </button>
            </>
          ) : (
            field.subfields.map((subField, subIndex) => (
              <div key={subIndex} className="form-group">
                <label className="form-label">{subField.fields}</label>
                {subField.api ? (
                  <select
                    className="form-select"
                    name={subField.fields}
                    value={item[subField.fields] || ''}
                    onChange={(e) =>
                      handleArrayChange(field.fields, index, subField.fields, e.target.value)
                    }
                  >
                    <option value="">Select {subField.fields}</option>
                    {dropdownData[subField.fields]?.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                ) : subField.options ? (
                  <select
                    className="form-select"
                    name={subField.fields}
                    value={item[subField.fields] || ''}
                    onChange={(e) =>
                      handleArrayChange(field.fields, index, subField.fields, e.target.value)
                    }
                  >
                    <option value="">Select {subField.fields}</option>
                    {subField.options.map((opt, idx) => (
                      <option key={idx} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    className="form-input"
                    type="text"
                    name={`${field.fields}-${subField.fields}`}
                    value={item[subField.fields] || ''}
                    onChange={(e) =>
                      handleArrayChange(field.fields, index, subField.fields, e.target.value)
                    }
                  />
                )}
              </div>
            ))
          )}
        </div>
      ))}

      <button
        type="button"
        onClick={() => handleAddItem(field.fields)}
        className="add-btn"
      >
        Add {field.fields}
      </button>
    </div>
  );
};

export default ArrayFieldSection;

export const getFormattedArrayFields = (formData, fields) => {
  const processedData = { ...formData };

  fields.forEach((field) => {
    // handle arrayString
    const isArrayString =
  Array.isArray(field.subfields) &&
  field.subfields.length === 1 &&
  field.subfields[0]?.type === 'arrayString';

const isSimpleArray = field.type === 'array' && !field.subfields;

const subFieldName = field.subfields?.[0]?.fields;

    if (isArrayString && Array.isArray(processedData[field.fields])) {
      processedData[field.fields] = processedData[field.fields]
        .map((item) => item?.[subFieldName])
        .filter(Boolean);
    }

    // handle simple array
    if (
      field.type === 'array' &&
      !field.subfields &&
      !field.checkBox &&
      Array.isArray(processedData[field.fields])
    ) {
      processedData[field.fields] = processedData[field.fields]
        .map((item) => item?.value || item)
        .filter(Boolean);
    }

    // ✅ handle checkBox (flat array of strings)
    if (field.checkBox && Array.isArray(processedData[field.fields])) {
      processedData[field.fields] = processedData[field.fields].filter(Boolean);
    }
  });

  return processedData;
};





